/**
 * 灯塔 SDK封装
 */
import dt from "@lianjia/fee-sdk";
import { getCookie } from "../utils";

export default () => {
  dt.set({
    pid: "saas-m-new-gs",
    ucid: getCookie("lianjia_uuid") || "",
    is_test: location.host != "app-kejinzu.ke.com",
    version: "1.1.10",
    record: {
      time_on_page: true,
      performance: true,
      js_error: true,
      js_error_report_config: {
        ERROR_RUNTIME: true,
        ERROR_SCRIPT: false,
        ERROR_STYLE: false,
        ERROR_IMAGE: false,
        ERROR_AUDIO: false,
        ERROR_VIDEO: false,
        ERROR_CONSOLE: false,
        ERROR_TRY_CATCH: true,
        checkErrorNeedReport: function(desc, stack) {
          return true;
        }
      }
    }
  });

  dt.sendError = ({ errorName, url, info }) => {
    dt.notify(errorName, url, info);
  };
  // 挂载到window
  window.$lianjiaDT = dt;
};
